import { combineReducers } from '@reduxjs/toolkit';
import development from './Development/slice';
import modalReducer from './modal-slice';
import { reducer as timesheetStatus } from './timesheet-status-slice';
import timesheets from './timesheets-slice';

const rootReducer = combineReducers({
  development,
  modal: modalReducer,
  timesheets,
  timesheetStatus,
});

export default rootReducer;
